import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'src/makeStyles';
import Card from '@mui/material/Card';


const useStyles = makeStyles()({
  root: {
    width: '100%',
    border: 'solid 1px rgba(151, 151, 151, 0.12)',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
  },
});

const ListCard = ({ children, className = {} }) => {
  const { classes, cx } = useStyles();

  return <Card className={cx(classes.root, className)}>{children}</Card>;
};

ListCard.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default ListCard;
